import React from "react";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "@transfr-inc/dashboard-components";

import { Button } from "@transfr-inc/dashboard-components/forms";

const SyncIntegrationModal = ({
  isOpen,
  onClose,
  initiateSync,
  providerName,
}) => {
  if (!isOpen) return;

  return (
    <div className={"sync-modal-container"}>
      <Modal
        modalClassName={"sync-integration-modal"}
        open={isOpen}
        onClose={onClose}
      >
        <ModalHeader
          icon={["fa-solid", "rotate"]}
          title="Sync Integrations"
        ></ModalHeader>
        <ModalBody className="sync-modal-body">
          Press Confirm to trigger a sync for all integrations set up with{" "}
          {getCapitalizedProvider(providerName)}.
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose}>Cancel</Button>
          <Button primary onClick={initiateSync}>
            Confirm
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

function getCapitalizedProvider(str) {
  if (!str) return "this provider";
  return str
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");
}

export default SyncIntegrationModal;
